import { useDispatch, useSelector } from 'react-redux'
import {
  clicksClear,
  clicksDelete,
  clicksDone,
  clicksKeyboardNumber,
} from '../../app/store/betslip/betslip.state'
import {
  selectKeyboard,
  selectDisableDigit,
} from '../../app/store/betslip/betslip.selectors'
import { Backspace } from '../svgs/index'
import { KeyboardWrapper, Button, Row } from './keyboard.style'
import { MutableRefObject } from 'react'

interface IKeyboard {
  betslipRef: MutableRefObject<HTMLDivElement | null>
  children?: React.ReactNode
}

export const Keyboard: React.FC<IKeyboard> = ({ betslipRef }) => (
  <KeyboardMotion betslipRef={betslipRef}>
    <KeyboardDigits />
    <KeyboardActions />
  </KeyboardMotion>
)

// --------------------------------------------------------------------------------

const KeyboardMotion: React.FC<IKeyboard> = ({ children, betslipRef }) => {
  const open = useSelector(selectKeyboard)

  const scrollDown = () => {
    const r = betslipRef?.current

    r?.scroll({
      behavior: 'smooth',
      top: r.scrollHeight - r.clientHeight,
    })
  }
  return (
    <KeyboardWrapper
      data-testid="keyboard-wrapper"
      onAnimationComplete={() => {
        scrollDown()
      }}
      variants={{
        opened: {
          height: 91,
          overflow: 'hidden',
          transition: {
            duration: 0.2,
            delay: 0,
          },
        },
        closed: {
          height: 0,
          overflow: 'hidden',
          transition: {
            duration: 0.2,
            delay: 0,
          },
        },
      }}
      animate={open ? 'opened' : 'closed'}
    >
      {children}
    </KeyboardWrapper>
  )
}

// --------------------------------------------------------------------------------

export const KeyboardDigits: React.FC = () => {
  const dispatch = useDispatch()
  const disabled = useSelector(selectDisableDigit)
  const handleValueClick = (n: number) => dispatch(clicksKeyboardNumber(n))

  return (
    <Row>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((n) => (
        <Button
          key={`keyboard-button-${n}`}
          data-testid={`keyboard-button-${n}`}
          width="100%"
          onClick={() => handleValueClick(n)}
          disabled={disabled}
        >
          {n}
        </Button>
      ))}
    </Row>
  )
}

// --------------------------------------------------------------------------------

const KeyboardActions = () => {
  const dispatch = useDispatch()
  const handleDone = () => dispatch(clicksDone())
  const handleDelete = () => dispatch(clicksDelete())
  const handleClear = () => dispatch(clicksClear())

  return (
    <Row>
      <Button
        data-testid="keyboard-button-clear"
        width="30%"
        onClick={handleClear}
      >
        Clear
      </Button>
      <Button
        data-testid="keyboard-button-delete"
        width="30%"
        onClick={handleDelete}
      >
        <span className="delete-button">
          <Backspace width="24" height="24" viewBox="0 0 24 24" />
        </span>
      </Button>
      <Button
        data-testid="keyboard-button-done"
        width="40%"
        onClick={handleDone}
      >
        Done
      </Button>
    </Row>
  )
}
